import { configureApi } from 'lp-requests'
import { middleware as configureMiddleware } from 'lp-redux-api'

export const { API_URL, API_KEY } = process.env

export const config = {
  root: API_URL,
  mode: 'cors',
  headers: {
    'X-Api-Key': API_KEY,
  },
}

export const middleware = configureMiddleware(config)
export const api = configureApi(config)
